const commentItems = [
  {
    id: 1,
    name: '漫画迷小陈',
    time: '3天前',
    avatar: 'ri-user-3-line',
    content: '用了51漫画免费版下载快两年了，资源真的很全，更新速度也快。最喜欢离线缓存功能，每天通勤路上看两话新番，完全不用流量，太赞了！',
    rating: 5,
  },
  {
    id: 2,
    name: '二次元老司机',
    time: '5天前',
    avatar: 'ri-user-3-line',
    content: '对比过好几个漫画站，5151漫画网的下载速度和画质确实是最好的。全集批量下载功能对于收藏党来说简直是神器，已经离线存了200多部作品了。',
    rating: 5,
  },
  {
    id: 3,
    name: '追番少女阿柠',
    time: '1周前',
    avatar: 'ri-user-3-line',
    content: '国漫专区做得特别好！一人之下和狐妖小红娘都是在这里追的，51漫画下载更新比别家快很多，画质也很清晰。推荐给所有国漫爱好者。',
    rating: 5,
  },
  {
    id: 4,
    name: '程序员看漫画',
    time: '1周前',
    avatar: 'ri-user-3-line',
    content: '界面简洁没有乱七八糟的广告，这点必须好评。51漫画免费版下载体验很流畅，就是希望APP能加入自动追更提醒功能，这样就更完美了。',
    rating: 4,
  },
  {
    id: 5,
    name: '日漫发烧友阿杰',
    time: '2周前',
    avatar: 'ri-user-3-line',
    content: '从大学用到现在毕业工作，5151漫画网一直很稳定。最近发现韩漫资源也越来越多，我独自升级全集就是在这下的，画质没得说，推荐给所有人！',
    rating: 5,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            读者评价
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            听听51漫画下载用户们的真实声音
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {commentItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center">
                    <i
                      className={`${
                        i < item.rating ? 'ri-star-fill text-primary-500' : 'ri-star-line text-foreground-300'
                      } text-sm`}
                    ></i>
                  </div>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                {item.content}
              </p>
              <div className="flex items-center gap-3 pt-3 border-t border-background-200/50">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-100">
                  <i className={`${item.avatar} text-primary-600 text-base`}></i>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-800">{item.name}</p>
                  <p className="text-xs text-foreground-500">{item.time}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}